import axios from 'axios'

const state = {
  orders: [],
  pagination: {}
}

const mutations = {
  SET_ORDERS(state, orders) {
    state.orders = orders
  },
  SET_PAGINATION(state, pagination) {
    state.pagination = pagination
  },
}

const actions = {

  async GET_ORDERS(context, data) {
    await axios.get('/orders/?page=' + data.page,{
      params: data
    })
      .then(response => {
        context.commit('SET_ORDERS', response.data.data)
        context.commit('SET_PAGINATION', {
          page: response.data.current_page,
          first_page_url: response.data.first_page_url,
          from: response.data.from,
          last_page: response.data.last_page,

          last_page_url: response.data.last_page_url,
          next_page_url: response.data.next_page_url,
          path: response.data.path,
          rowsPerPage: response.data.per_page,
          prev_page_url: response.data.prev_page_url,
          to: response.data.to,
          totalItems: response.data.total,
        })
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
